// Copyright (c) 2020 Deere & Company

import './busy-counter-loading-indicator.scss';
import React from 'react';

export const LoadingIndicator = () => (
    <div className="loading-indicator">
        <div className="loading-dot dot-bounce-delay1" />
        <div className="loading-dot dot-bounce-delay2" />
        <div className="loading-dot dot-bounce-delay3" />
        <div className="loading-dot dot-bounce-delay4" />
    </div>
);
